import { useMutation, useQueryClient } from "@tanstack/react-query";

import {
  patchProjectsProjectIDJobsJobIDStatus,
  type UpdateJobStatusRequest,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { PROJECTS_QUERY_KEYS } from "../Queries/queryKeys";

interface UpdateJobStatusParams {
  projectID: string;
  jobID: string;
  isActive: boolean;
}

export function useUpdateJobStatusMutation() {
  const queryClient = useQueryClient();

  const mutationFn = processResponse(
    ({ projectID, jobID, isActive }: UpdateJobStatusParams) => {
      const request: UpdateJobStatusRequest = { isActive };
      return patchProjectsProjectIDJobsJobIDStatus(request, projectID, jobID);
    },
  );

  return useMutation({
    mutationFn,
    onSuccess: (_, { projectID, jobID }) => {
      queryClient.invalidateQueries({
        queryKey: PROJECTS_QUERY_KEYS.jobs(projectID),
      });
      queryClient.invalidateQueries({
        queryKey: PROJECTS_QUERY_KEYS.jobDetail(projectID, jobID),
      });
    },
  });
}
